import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Swal from "sweetalert2";
import RichTextEditor from "react-rte";
import MailOutline from "@material-ui/icons/MailOutline";
import Slider from "nouislider";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import Datetime from "react-datetime";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import axios from "../../utils/axiosInstance";
import defaultImage from "assets/img/image_placeholder.jpg";
import defaultAvatar from "assets/img/placeholder.jpg";
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import reactDom from "react-dom";
import stylesData from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
const useStyles = makeStyles(styles);
import SweetAlert from "react-bootstrap-sweetalert";
const useStyleData = makeStyles(stylesData);
import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import moment from "moment";
;
import { Box, Checkbox, FormControlLabel, Input } from "@material-ui/core";

import { LoadingButton } from "@mui/lab";


export default function ViewLottery() {
  let fileInput = React.createRef();
  let { lotteryId } = useParams();
  const navigate = useNavigate();

  const [formValues, setFormValues] = React.useState({
    lotteryName: "",
    ticketPrice: 0,
    numOfTicketOnSale: 0,
    ticketCountdown: 0,
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
    lotteryDrawDate: "",
    lotteryDrawTime: "",
    totalDraw: 0,
    instruction: "",
    // maxRpmLotteryWheel: 0,
    decelarationOfLotteryWheel: 20,
    maxNumOfTickets: 0,
    lastTwoTktNumPrice: 0,
    status: "",
    endDateTime: "",
    drawPrize: [],
    startDateTime: "",
    maxTktPurchLimit: "",
    lastTwoSpinNum: [],
    jackpotSelected: false,
  });



  const [selectedStartTime, setSelectedStartTime] = React.useState(null);
  const [selectedEndTime, setSelectedEndTime] = React.useState(null);
  const [drawDateTime, setDrawDateTime] = React.useState(null);
  const [decelarationOfWheel, setDecelarationOfWheel] = React.useState(60);
  const [rpmOfWheel, setrpmOfWheel] = React.useState(3);
  const [file, setFile] = React.useState(null);

  const [totalSpin, setTotalSpin] = useState(2);
  const [lastTwoSpinNums, setlastTwoSpinNums] = React.useState(
    Array(totalSpin).fill(0)
  );
  const [avatar, setAvatar] = React.useState(true);
  const [loading, setLoading] = React.useState(true);
  const [imagePreviewUrl, setImagePreviewUrl] = React.useState(
    avatar ? defaultAvatar : defaultImage
  );
  const [imageurl, setImageurl] = React.useState("");
  const [alert, setAlert] = React.useState(null);
  const [editorBody, setEditorBody] = React.useState(
    RichTextEditor.createEmptyValue()
  );
  const [totalDraw, setTotalDraw] = useState(3);
  const [drawPrizes, setDrawPrizes] = React.useState(Array(totalDraw).fill(0));
  const [initialLoaded, setInitialLoaded] = useState(false);
  React.useEffect(() => {
    generateTextFields();
  }, [formValues.totalDraw]);
  React.useEffect(() => {
    generateSpinTextFields();
  }, [formValues.totalSpin]);
  React.useEffect(() => {
    if (formValues.instruction && !initialLoaded) {
      setEditorBody(RichTextEditor.createValueFromString(formValues.instruction, 'html'));
      setInitialLoaded(true);
    }
  }, [formValues.instruction, initialLoaded]);
  const generateTextFields = () => {
    const textFields = [];
    for (let i = 0; i < formValues.totalDraw; i++) {
      textFields.push(i);
    }
    return textFields.map((index) => (
      <GridItem key={index} xs={12} sm={12} md={3}>
        <CustomInput
          labelText={`Draw Prize ${index + 1}`}
          id={`drawPrize${index}`}
          type="number"
          formControlProps={{
            fullWidth: true,
          }}
          value={drawPrizes[index] || ""}
          handleChange={(event) => handleDrawChange(event, index)}
          inputProps={{
            type: "number",
            value: drawPrizes[index],
            disabled: true,
          }}
        />
      </GridItem>
    ));
  };

  const generateSpinTextFields = () => {
    const textFields = [];
    for (let i = 0; i < formValues.totalSpin; i++) {
      textFields.push(i);
    }
    return textFields.map((index) => (
      <GridItem key={index} xs={12} sm={12} md={3}>
        <CustomInput
          labelText={`Spin free ticket run  ${index + 1}`}
          id={`spin${index}`}
          type="number"
          formControlProps={{
            fullWidth: true,
          }}
          value={lastTwoSpinNums[index] || ""}
          handleChange={(event) => handleSpinChange(event, index)}
          inputProps={{
            type: "number",
            value: lastTwoSpinNums[index],
            disabled: true,
          }}
        />
      </GridItem>
    ));
  };

  React.useEffect(() => {
    if (
      document?.getElementById("maxRpmLotteryWheel") !== null &&
      !document
        ?.getElementById("maxRpmLotteryWheel")
        ?.classList?.contains("noUi-target")
    ) {
      Slider.create(document?.getElementById("maxRpmLotteryWheel"), {
        start: [formValues.maxRpmLotteryWheel],
        tooltips: true,
        connect: [true, false],
        step: 1,
        // value: formValues.maxRpmLotteryWheel,
        range: { min: 60, max: 120 },
      }).on("update", (values, handle) => {
        // Update state when the slider value changes

        setrpmOfWheel(parseFloat(values[handle]));
        console.log(values);
      });
    }
    if (
      document?.getElementById("maxRpmLotteryWheel") !== null &&
      !document
        ?.getElementById("decelarationOfLotteryWheel")
        ?.classList?.contains("noUi-target")
    ) {
      Slider.create(document?.getElementById("decelarationOfLotteryWheel"), {
        start: [formValues.decelarationOfLotteryWheel],
        connect: [true, false],
        tooltips: true,
        step: 1,
        // value: formValues.decelarationOfLotteryWheel,
        range: { min: 3, max: 7 },
      }).on("update", (values, handle) => {
        // Update state when the slider value changes

        setDecelarationOfWheel(parseFloat(values[handle]));
        console.log(values);
      });
    }
    return function cleanup() { };
  });
  React.useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      setLoading(true);
      try {
        await axios
          .get(
            `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/lottery/${lotteryId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Access-Control-Allow-Origin": "*",
              },
            }
          )
          .then((res) => {
            const data = res.data.data;
            setSelectedStartTime(
              moment(`2023-11-16T${data.startTime}`).format("hh:mm A")
            );
            setSelectedEndTime(
              moment(`2023-11-16T${data.endTime}`).format("hh:mm A")
            );
            setDrawDateTime(
              moment(`${data.lotteryDrawDate}`).format("YYYY-MM-DD hh:mm A")
            );
            setFormValues({
              lotteryName: data.lotteryName,
              ticketPrice: data.ticketPrice,
              numOfTicketOnSale: data.numOfTicketOnSale,
              ticketCountdown: data.ticketCountdown,
              startDate: data.startDate,
              endDate: data.endDate,
              startTime: data.startTime,
              endTime: data.endTime,
              lotteryDrawDate: data.lotteryDrawDate,
              lotteryDrawTime: data.lotteryDrawTime,
              totalDraw: data.totalDraw,
              instruction: data.instruction,
              maxRpmLotteryWheel: data.maxRpmLotteryWheel,
              decelarationOfLotteryWheel: data.decelarationOfLotteryWheel,
              maxNumOfTickets: data.maxNumOfTickets,
              status: data.status,
              endDateTime: data.endDateTime,
              startDateTime: data.startDateTime,
              lastTwoTktNumPrice: data.lastTwoTktNumPrice,
              imagePreviewUrl: `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/uploads/${data.image}`,
              maxTktPurchLimit: data.maxTktPurchLimit,
              totalSpin: data.lastTwoSpinNum.length,
              jackpotSelected: data.jackpotSelected,
            });

            setDrawPrizes((prevState) => [...data.drawPrize]);
            setlastTwoSpinNums([...data.lastTwoSpinNum]);
            setImagePreviewUrl(
              `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/uploads/${data.image}`
            );
          });
      } catch (error) {
        console.error(error.message);
        if (
          error?.response?.data?.message ==
          "For security reasons, we locked your account.Please login to continue"
        ) {
          localStorage.removeItem("token");
          window.location.assign("/auth/login-page");
        } else {
          Swal.fire({
            text: error.response.data.message,
          });
        }
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  const classes = useStyles();
  const classesSweetAlert = useStyleData();
  return (
    <>
      {loading && <div>Loading</div>}
      {!loading && (
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <MailOutline />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>View Lottery</h4>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer>
                    <GridItem xs={12} sm={4} md={12}>
                      <legend>Lottery Image</legend>
                      {console.log(imagePreviewUrl, "imageeeeeeeeeeeeeee")}
                      <ImageUpload
                        avatar
                        fileValue={file}
                        imagePreviewUrlValue={imagePreviewUrl}
                        viewMode={true}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <CustomInput
                        labelText="Lottery Name"
                        id="lotteryName"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          value: formValues.lotteryName,
                          disabled: true,
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                      <CustomInput
                        labelText="Maximum Number Of Tickets"
                        type="number"
                        id="maxNumOfTickets"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "number",
                          value: formValues.maxNumOfTickets,
                          disabled: true,
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <CustomInput
                        type="number"
                        labelText="Ticket Price"
                        id="ticketPrice"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        disabled={true}
                        inputProps={{
                          type: "number",
                          value: formValues.ticketPrice,
                          //   disabled: true,
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <CustomInput
                        labelText="Number Of Ticket On Sale"
                        type="number"
                        id="numOfTicketOnSale"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        value={formValues.numOfTicketOnSale}
                        inputProps={{
                          type: "number",
                          value: formValues.numOfTicketOnSale,
                          disabled: true,
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <CustomInput
                        labelText="Start Date and Time"
                        id="startDateTime"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text", // Keep it as text since it's just for display
                          value:
                            formValues.startDate && formValues.startTime
                              ? moment
                                .utc(`${formValues.startDate}T${formValues.startTime}`)
                                .local()
                                .format("YYYY-MM-DD hh:mm A") // 👉 "2025-09-05 12:00 AM"
                              : "",
                          disabled: true, // Ensure it's only for viewing
                        }}
                      />
                    </GridItem>

                    {/* <GridItem xs={12} sm={12} md={3}>
                      <InputLabel className={classes.label}>
                        End Date and Time
                      </InputLabel>
                      <br />
                      <FormControl fullWidth>
                        <Input
                          value={`${formValues.endDate} ${formValues.endTime}`}
                          disabled
                        />
                      </FormControl>
                    </GridItem> */}
                    <GridItem xs={12} sm={12} md={3}>
                      <CustomInput
                        labelText="End Date and Time"
                        id="endDateTime"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text", // Keep it as text since it's just for display
                          value:
                            formValues.endDate && formValues.endTime
                              ? moment
                                .utc(`${formValues.endDate}T${formValues.endTime}`)
                                .local()
                                .format("YYYY-MM-DD hh:mm A") // 👉 "2025-09-05 12:00 AM"
                              : "",
                          disabled: true, // Ensure it's only for viewing
                        }}
                      />
                    </GridItem>
                    {/* <GridItem xs={12} sm={12} md={3}>
                      <InputLabel className={classes.label}>
                        Lottery Draw Date and Time
                      </InputLabel>
                      <br />
                      <FormControl fullWidth>
                        <Input value={formValues.lotteryDrawDate} disabled />
                      </FormControl>
                    </GridItem> */}
                    <GridItem xs={12} sm={12} md={3}>
                      <CustomInput
                        labelText="Lottery Draw Date"
                        id="drawDate"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          value: `${drawDateTime}`,
                          disabled: true,
                        }}
                      />
                    </GridItem>

                    <GridItem xs={12} sm={12} md={3}>
                      <FormControl
                        fullWidth
                        className={classes.selectFormControl}
                      >
                        <InputLabel
                          htmlFor="simple-select"
                          className={classes.selectLabel}
                        >
                          Status
                        </InputLabel>
                        <Select
                          id="status"
                          MenuProps={{
                            className: classes.selectMenu,
                          }}
                          classes={{
                            select: classes.select,
                          }}
                          inputProps={{
                            name: "status",
                            id: "status",
                            value: formValues.status,
                          }}
                          disabled
                        >
                          <MenuItem
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value={true}
                          >
                            Active
                          </MenuItem>
                          <MenuItem
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value={false}
                          >
                            Inactive
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      {" "}
                      <CustomInput
                        labelText="Total Draw"
                        type="number"
                        id="totalDraw"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "number",
                          value: formValues.totalDraw,
                          disabled: true,
                        }}
                      />
                    </GridItem>
                    {generateTextFields()}
                    <GridItem xs={12} sm={12} md={3}>
                      <CustomInput
                        labelText="Free ticket spins"
                        type="number"
                        id="totalSpin"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "number",
                          value: formValues.totalSpin,
                          disabled: true,
                        }}
                      />
                    </GridItem>
                    {generateSpinTextFields()}
                    <GridItem xs={12} sm={12} md={3}>
                      <CustomInput
                        labelText="Spin free ticket Price"
                        type="number"
                        id="lastTwoTktNumPrice"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "number",
                          value: formValues.lastTwoTktNumPrice,
                          disabled: true,
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <legend>Maximum Rpm Lottery Wheel</legend>
                      <div className="slider-primary" id="maxRpmLotteryWheel" />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <legend>Decelaration Of Lottery Wheel</legend>
                      <div
                        className="slider-primary"
                        id="decelarationOfLotteryWheel"
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                      <CustomInput
                        labelText="Maximum Number Of Tickets"
                        type="number"
                        id="maxNumOfTickets"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "number",
                          value: formValues.maxNumOfTickets,
                          disabled: true,
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                      <CustomInput
                        labelText="Max Ticket Purchase Limit"
                        type="number"
                        id="maxTktPurchLimit"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "number",
                          value: formValues.maxTktPurchLimit,
                          disabled: true,
                        }}
                      />
                    </GridItem>

                    <GridItem xs={12} sm={12} md={4} sx={{ padding: "10px" }}>
                      <Box display="flex" alignItems="flex-end" height="100%">
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              id="jackpotSelected"
                              checked={formValues.jackpotSelected}
                              disabled
                            />
                          }
                          label="Enable Jackpot"
                        />
                      </Box>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <InputLabel className={classes.label}>
                        Instruction
                      </InputLabel>
                      <br />
                      <RichTextEditor
                        value={editorBody}
                        style={{ height: "300px" }}
                        readOnly
                      />
                    </GridItem>
                  </GridContainer>
                  {alert}
                  <LoadingButton
                    // color="rose"

                    className={classes.registerButton}
                    onClick={() => navigate(-1)}
                    variant="outlined"
                  >
                    Back
                  </LoadingButton>
                </form>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      )}
    </>
  );
}
